import { render, staticRenderFns } from "./Next.vue?vue&type=template&id=77874037&scoped=true&"
import script from "./Next.vue?vue&type=script&lang=js&"
export * from "./Next.vue?vue&type=script&lang=js&"
import style0 from "./Next.vue?vue&type=style&index=0&id=77874037&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77874037",
  null
  
)

export default component.exports